/* global axios */

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class CrossBrandReportsAPI {
  constructor() {
    this.url = '/api/v2/cross_brand_reports';
  }

  // Get agent summary across all accessible brands
  getAgents({ since, until, businessHours, groupBy } = {}) {
    return axios.get(`${this.url}/agents`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        group_by: groupBy,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // Get individual sessions for a specific agent across all brands
  getAgentSessions({
    userId,
    since,
    until,
    businessHours,
    metricFilter,
    threshold,
    thresholdOperator,
    accountId,
    inboxId,
    page,
    perPage,
  } = {}) {
    return axios.get(`${this.url}/agent_sessions`, {
      params: {
        user_id: userId,
        since,
        until,
        business_hours: businessHours,
        metric_filter: metricFilter,
        threshold,
        threshold_operator: thresholdOperator,
        account_id: accountId,
        inbox_id: inboxId,
        page,
        per_page: perPage,
      },
    });
  }
}

export default new CrossBrandReportsAPI();
